<template>
	<v-layout row justify-center style="position: absolute;">
	<v-dialog
		:value="loading"
		persistent
		fullscreen
		transition="none"
		content-class="loading-dialog"
	>
		<v-container fill-height>
			<v-layout row justify-center align-center>
				<v-progress-circular
					indeterminate
					:size="70"
					:width="7"
					color="primary"
				></v-progress-circular>
			</v-layout>
		</v-container>
	</v-dialog>
</v-layout>
</template>

<script>
export default {
	computed: {
		loading() {
			return this.$store.getters['app/isLoading']
		},
	},
}
</script>

<style>
.loading-dialog {
  background-color: #30303030
}
</style>
